<div class="tw-px-4 tw-pt-4">
  <div class="tw-mb-4 tw-flex tw-items-center tw-gap-2">
    <p class="tw-font-body tw-text-200 tw-font-medium tw-uppercase tw-tracking-wider tw-text-gray-800 tw-whitespace-nowrap" i18n="@@moreForYou">More for you</p>
    <div class="tw-h-px tw-flex-1 tw-bg-gray-300"></div>
  </div>

  <div class="tw-grid tw-grid-cols-2 tw-gap-3">
    <!-- Take photo analysis (spans both rows) -->
    <div class="tw-relative tw-row-span-2 tw-overflow-hidden tw-rounded-2 tw-bg-teal-500" (click)="navigateToTakePhotoAnalysis()">
      <img [src]="takePhotoArt().src" alt="take-photo-image" class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover" [class.-tw-scale-x-100]="takePhotoArt().mirrored" />

      <!-- AI analysis badge (reused from analysis-banner) -->
      <span class="tw-absolute tw-left-1.5 tw-top-1.5 tw-z-[8] apply-container before:tw-rounded-5 before:tw-absolute before:tw-inset-0 before:tw-z-[-1] before:tw-p-[1.5px]">
        <div class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-pl-2 tw-pr-3 tw-py-[1.4px] tw-m-0.5 tw-rounded-full" style='background-color: rgba(0,0,0,0.5)'>
          <cs-icon [iconName]="'https://cdn.cureskin.com/app/img/ai_analysis_icon.svg'" class="tw-w-4 tw-h-4"></cs-icon>
          <p class="tw-text-[9px] tw-text-white tw-uppercase tw-font-bold tw-font-body" i18n="@@aiAnalysis">ai analysis</p>
        </div>
      </span>

      <!-- bottom copy on a solid teal background that grows with its content -->
      <div class="tw-absolute tw-inset-x-0 tw-bottom-0 tw-bg-teal-500 tw-px-2 tw-pb-2 tw-pt-2">
        <p class="tw-font-lexend tw-text-300 tw-font-bold tw-text-gray-75" i18n="@@takePhotoAnalysis">Take photo analysis</p>
        <p class="tw-font-lexend tw-text-200 tw-text-gray-75 tw-opacity-70" i18n="@@trackYourProgress">Track your progress</p>
      </div>
    </div>

    <!-- Refer & Earn -->
    <div class="tw-relative tw-flex tw-min-h-27 tw-items-center tw-overflow-hidden tw-rounded-2 tw-bg-gray-75 tw-shadow-z4" (click)="navigateToRefer()">
      <div class="tw-flex tw-flex-col tw-items-start tw-gap-2 tw-pl-3 tw-py-2">
        <div class="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100">
          <cs-icon class="tw-h-6 tw-w-6" [iconName]="'cureskin_cash_coin'"></cs-icon>
        </div>
        <div>
          <p class="tw-font-lexend tw-text-200 tw-text-gray-500" i18n="@@earn400">Earn ₹400</p>
          <p class="tw-font-lexend tw-text-500 tw-font-bold tw-text-gray-800" i18n="@@referAndEarn">Refer & Earn</p>
        </div>
      </div>
    </div>

    <!-- Report a reaction / Take Help -->
    <div class="tw-relative tw-flex tw-min-h-27 tw-items-center tw-overflow-hidden tw-rounded-2 tw-bg-gray-75 tw-shadow-z4" (click)="handleReportReactionClick()">
      <div class="tw-flex tw-flex-col tw-items-start tw-gap-2 tw-pl-3 tw-py-2">
        <div class="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100">
          <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-800" [iconName]="'report_icon'"></cs-icon>
        </div>
        <div>
          <p class="tw-font-lexend tw-text-200 tw-text-gray-500" i18n="@@reportAReaction">Report a reaction?</p>
          <p class="tw-font-lexend tw-text-500 tw-font-bold tw-text-gray-800 tw-capitalize" i18n="@@takeHelp">Take help</p>
        </div>
      </div>
    </div>
  </div>
</div>
